const MOBILE_BREAKPOINT = 768;

function disableNavbarMobileScroll() {
  if (screen.width >= MOBILE_BREAKPOINT) return;
  document.body.classList.add("no-scroll");
}

function enableNavbarMobileScroll() {
  document.body.classList.remove("no-scroll");
}

export {
  disableNavbarMobileScroll,
  enableNavbarMobileScroll,
  MOBILE_BREAKPOINT,
};
